import appConfig from './app.json';

interface LegalDocumentsAppConfig {
  legal?: {
    dataPrivacyPolicyUrl?: string;
  };
}

interface LegalDocuments {
  copyright: string;
  dataPrivacyPolicyUrl?: string;
}

export const getLegalDocuments = (
  config: LegalDocumentsAppConfig = appConfig as LegalDocumentsAppConfig,
): LegalDocuments => {
  const dataPrivacyPolicyUrl = config.legal?.dataPrivacyPolicyUrl;

  return {
    copyright: dataPrivacyPolicyUrl ? 'MMIS, Inc. All Rights Reserved' : 'Alucio, Inc.',
    dataPrivacyPolicyUrl,
  };
};

export const openExternalLink = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
